/**
 * Market making management API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Pair } from './pair';

export interface MarketMakingPairSetting {
  id?: number;
  exchangeSymbol?: string;
  exchangeSecurityId?: string;
  pairId?: number;
  pair?: Pair;
  compId?: string;
  enabled?: boolean;
  makerCommissionRate?: number;
  takerCommissionRate?: number;
  platformMakerFee?: number;
  platformTakerFee?: number;
  maxLoss?: number;
  qtyScale?: number;
  priceScale?: number;
  lvl1?: number;
  minSpreadLvl1?: number;
  lvl2?: number;
  minSpreadLvl2?: number;
  lvl3?: number;
  minSpreadLvl3?: number;
  lvl4?: number;
  minSpreadLvl4?: number;
  lvl5?: number;
  minSpreadLvl5?: number;
  eventDetectionLpId?: number;
  eventDetectionLpCrossedEntity?: boolean;
  eventDetectionBps?: number;
}
